// Module
var code = " <div class=\"jumbotron\" data-pages=\"parallax\"> <div class=\"container-fluid container-fixed-lg sm-p-l-20 sm-p-r-20\"> <div class=\"inner\"> <ul class=\"breadcrumb\"> <li> <p>Pages</p> </li> <li><a href=\"\" class=\"active\">Barebone template</a> </li> </ul> </div> </div> </div> ";
// Exports
module.exports = code;